<template>
<div>
<ContentHeader v-if="item"  :title="inputfield_name"  :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don" url="SupplierProjectFlowSummary" :urlparams="headerurlparams"></ContentHeader>


<div class="content_card" >
<div class="grid">

<div class="col-12">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">

<div class="grid">
<div class="col-12 md:col-7">
<CustomInputfield :data="item.inputfield"></CustomInputfield>
</div>


<div class="col-12 md:col-5">
<NonconformityPanelForAdmin :nonconformity="item" @nonconformityDataUpdated="nonconformityDataUpdated" :nonconformitytypes="nonconformitytypes" @inputfieldcorrection="inputfieldcorrection"></NonconformityPanelForAdmin>
</div>
</div>	
</div>

</div>
</div>
</div>


</div>	
</template>

<script>
export default {

  name: 'SupplierFlowNonconformity',
  props:["nonconformity"],

  data () {
    return {
    	item:null,
    	loading:true,
    	flowsupplier:null,
    	projectsupplier:null,
      nonconformitytypes:[],
      null_mutated:false,
    }
  },
  computed:{
  	inputfield_name()
  	{
  		if(this.item)
  		{
  			return this.getTheTranslation(this.item.inputfield,"translation")
  		}
  		return null
  	},
  	headerurlparams()
  	{
  		if(this.projectsupplier && this.flowsupplier)
  		{
  			return {project_id:this.projectsupplier.uuid,flow_id:this.flowsupplier.uuid}
  		}
  		return null
  	}
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
    inputfieldcorrection(data)
    {
      if(data)
      {
        this.item.inputfield.read_only_state = false
        this.item.inputfield.show_info_textarea = true
        this.item.inputfield.show_evidence_btn = true        
        if(this.item.inputfield.submissions.length)
        {
          if(this.item.inputfield.submissions[0].is_nulled)
          {
            this.item.inputfield.submissions[0].is_nulled = 0
            this.null_mutated = true
          }
          
        }
      }
      else
      {
        this.item.inputfield.read_only_state = true
        this.item.inputfield.show_info_textarea = true
        this.item.inputfield.show_evidence_btn = false     
        if(this.null_mutated)
        {
          this.null_mutated = false
          this.item.inputfield.submissions[0].is_nulled = 1
        }
      }
    },
  	prepareNonconformity(nonconformity)
    {
      let obj = nonconformity.inputfield
      obj.completion = true
      obj.show_evidence_btn = false
      obj.show_info_textarea = false
      obj.read_only_state = true
      obj.show_field = true
      
      nonconformity.inputfield = obj
      nonconformity.inputfield_name = nonconformity.inputfield.name
      

      return nonconformity
    },
  	async getData()
  	{
  		this.loading = true
  		let data = await this.generalApiGetWithoutLoader("audit/get_nonconformity_data/"+this.$route.params.nonconformity_id)
      console.log("data")
      console.log(data)
  		this.item = await this.prepareNonconformity(data.nonconformity)
      console.log(this.item)
      if(data.qulist_options.length && !data.nonconformity.inputfield.options.length)
      {
        this.item.inputfield.options = data.qulist_options
      }
  		this.flowsupplier = await data.flowsupplier
      this.projectsupplier = await data.projectsupplier
      this.nonconformitytypes = await data.nonconformitytypes
  		await this.$store.dispatch('evaluation/setMode',"viewing")
      await this.$store.dispatch('evaluation/setEvaluation',data.flowsupplier) 
  		this.loading = false
  	},
  	nonconformityDataUpdated(data)
  	{  		     
      	this.item = this.prepareNonconformity(data)
  	},
  }
}
</script>

<style lang="css" scoped>
</style>